import { useMutation, useQuery } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';
import { EventReport, EventReportClient, EventReportFilter, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const eventReportClient = new EventReportClient(apiBaseUrl);
function useGetFilteredEventReports() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation<EventReport[], ProblemDetails, EventReportFilter[]>({
    mutationKey: [queryKeys.EventReport.Filtered],
    mutationFn: (filter: EventReportFilter[]) => eventReportClient.getFilteredEventReports(filter),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useGetFilteredEventReports;
